/**
 * @prettier
 */

/**
 * Takes an array, and returns a comma separated string, with conjunction at the end.
 * For example:
 *
 * ['one','two','three','four'], 'and'
 * 'one, two, three, and four'
 *
 * @param {Array} arr - Array to be joined
 * @param {string} conj - conjunction to be used
 *
 * @return {string}
 */
export function makeCommaSeparatedString(arr, conj) {
    const listStart = arr.slice(0, -1).join(', ');
    const listEnd = arr.slice(-1);
    const final =
        arr.length <= 1
            ? ''
            : arr.length > 2
              ? ', ' + conj + ' '
              : ' ' + conj + ' ';

    return [listStart, listEnd].join(final);
}
